import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";
import { ConfigService } from "../../services/config.service";

@Component({
  selector: "page-fannel-applicants",
  templateUrl: "fannel-applicants.html"
})
export class FannelApplicantsPage {
  applicants: any[] = [];
  fannel: any;
  winners: any[] = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private configService: ConfigService,
    public viewCtrl: ViewController
  ) {
    this.fannel = this.navParams.get("fannel");
    var num = 1;
    if (!this.fannel.finish) {
      while (this.fannel["applicants" + num]) {
        this.applicants.push(this.fannel["applicants" + num]);
        console.log(
          "Fannel Applicants " + this.fannel["applicants" + num].name
        );
        num++;
      }
    }
    if (this.fannel.finish) {
      while (this.fannel["winner" + num]) {
        this.winners.push(this.fannel["winner" + num]);
        console.log("Fannel winner " + this.fannel["winner" + num].name);
        num++;
      }
    }
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad FannelApplicantsPage");
  }

  ionViewWillEnter() {}
}



// WEBPACK FOOTER //
// ./src/pages/fannel-applicants/fannel-applicants.ts